document.addEventListener('DOMContentLoaded', () => {
  const sliderSections = document.querySelectorAll('.collection-slider-section');
  
  sliderSections.forEach(section => {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    const sorter = section.querySelector(`#sort-by-${sectionId}`);
    const wrapper = section.querySelector(`#slider-wrapper-${sectionId}`);

    
    const prevButton = section.querySelector('.slider-arrow--prev');
    const nextButton = section.querySelector('.slider-arrow--next');

    if (!wrapper) return;
    
    
    const updateArrowState = () => {
      if (!prevButton || !nextButton) return; 

      const scrollLeft = wrapper.scrollLeft;
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      
      
      prevButton.disabled = scrollLeft < 10;
      nextButton.disabled = scrollLeft > maxScroll - 10;
    };


  
    if (prevButton && nextButton) {
      prevButton.addEventListener('click', () => {
        const scrollAmount = wrapper.clientWidth * 0.8;
        wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        const scrollAmount = wrapper.clientWidth * 0.8;
        wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
      
      
      wrapper.addEventListener('scroll', updateArrowState);
      
      
      new ResizeObserver(updateArrowState).observe(wrapper);
      
      
      updateArrowState();
    }


    
    wrapper.addEventListener('wheel', (event) => {
      if (!event.shiftKey) {
        return; 
      }
      event.preventDefault(); 
      wrapper.scrollLeft += event.deltaY;
    }, { passive: false });


    
    let isDown = false;
    let startX;
    let scrollLeft;

    wrapper.addEventListener('mousedown', (e) => {
      isDown = true;
      wrapper.classList.add('active-grabbing');
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    });

    wrapper.addEventListener('mouseleave', () => {
      isDown = false;
      wrapper.classList.remove('active-grabbing');
    });

    wrapper.addEventListener('mouseup', () => {
      isDown = false;
      wrapper.classList.remove('active-grabbing');
    });

    wrapper.addEventListener('mousemove', (e) => {
      if (!isDown) return; 
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      const walk = (x - startX) * 2;
      wrapper.scrollLeft = scrollLeft - walk;
    });


    
    if (sorter) {
      sorter.addEventListener('change', (e) => {
        const sortValue = e.target.value;
        const cards = wrapper.querySelectorAll('.collection-slider__product-card');
        const cardsArray = Array.from(cards);

        cardsArray.sort((a, b) => {
          switch (sortValue) {
            case 'title-ascending':
              return a.dataset.title.localeCompare(b.dataset.title);
            case 'title-descending':
              return b.dataset.title.localeCompare(a.dataset.title);
            case 'price-ascending':
              return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
            case 'price-descending':
              return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
            case 'manual':
            default:
              return parseInt(a.dataset.index, 10) - parseInt(b.dataset.index, 10);
          }
        });

        wrapper.innerHTML = '';
        cardsArray.forEach(card => {
          wrapper.appendChild(card);
        });
        
        
        updateArrowState();
      });
    }

  });
});